module.exports = __webpack_public_path__ + "static/media/image7.d9521090.jpeg";